export const archiveActionItemsTooltipIds = {
  CELL_TOOLTIP_ID: 'cell-tooltip',
  SORT_TOOLTIP_ID: 'sort-tooltip',
  LONG_TEXT_TOOLTIP_ID: 'long-text-tooltip',
};
